import type { FC, ReactNode } from 'react'
import React from 'react'
import clsx from 'clsx'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import type { ITheme } from '@homeviews/styles'
import { useDispatch } from 'react-redux'
import { toggleUpgradeForm } from '@homeviews/store'
import Button from '../Button'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 8,
      color: theme.colors.white,
      width: 'calc(100% + 32px)',
      marginLeft: -16,
      marginRight: -16,
      marginTop: -24,
      marginBottom: 24,
      '& .l-infoBanner__icon': {},
      '& .l-infoBanner__title': {
        position: 'relative',
        color: theme.colors.white,
        paddingLeft: 20,
        marginBottom: 5,
        marginTop: 5,
        marginRight: 10,
        '&:before': {
          content: '""',
          backgroundImage: 'url("assets/icons/secure.svg")',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 14,
          position: 'absolute',
          top: 2.5,
          left: 0,
          width: 16,
          height: 16,
        },
      },
      '& .l-infoBanner__ctaButton': {},
    },
    gold: {
      backgroundColor: theme.colors.gold,
    },
    green: {
      backgroundColor: theme.colors.primary,
    },
    inner: {
      display: 'flex',
    },
  }),
)

interface IProps {
  className?: string
  children: ReactNode
  theme: 'green' | 'gold'
  upgrade?: boolean
}

const InfoBanner: FC<IProps> = ({ children, theme, upgrade }) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  return (
    <div className={clsx(classes.root, classes[theme])}>
      <div className={classes.inner}>
        {children}
        {upgrade && (
          <Button
            customVariant="containedWhite"
            size="small"
            onClick={() => dispatch(toggleUpgradeForm({ open: true }))}
          >
            Upgrade
          </Button>
        )}
      </div>
    </div>
  )
}

export default InfoBanner
